export enum SignUpTypeEnum {
  GOOGLE = 'GOOGLE',
  GITHUB = 'GITHUB',
  LINKEDIN = 'LINKEDIN',
  EMAIL = 'EMAIL',
}
 export enum MenuTypeEnum {
  HAMBURGER = 'HAMBURGER',
   COLLAPSE = 'COLLAPSE'
 }
